var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{staticClass:"me-field",class:{ 'me-field--edit': _vm.editable }},[_c('span',{staticClass:"me-field__label",attrs:{"slot":"label"},slot:"label"},[_vm._t("label",function(){return [_vm._v(_vm._s(_vm.label))]})],2),(_vm.editable)?_vm._t("default"):_c('div',{staticClass:"me-field__value"},[_vm._v(_vm._s(_vm.display))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }